<template>
  <!-- 志愿者查看 -->
  <el-dialog class="dialog-volunteer-detail" :append-to-body="true" @close="cancel" :visible.sync="dialogVisible" title="查看" width="1000px">
    <div class="wrap">
      <el-tabs class="content-tabs" v-model="activeName">
        <el-tab-pane label="基本信息" name="1">
          <el-row :gutter="20">
            <el-form class="g-form-grid" ref="addForm" :model="detailData" label-width="145px">
              <el-col :span="12">
                <el-form-item label="姓名 :" prop="realName">
                  <el-input v-model="detailData.realName" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="身份证号 :" prop="idCard">
                  <el-input v-model="detailData.idCard" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="年龄 :" prop="parentName">
                  <el-input v-model="detailData.parentName" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别 :" prop="sex">
                  <el-radio-group v-model="detailData.sex" :disabled="operation  == 'detail'">
                    <el-radio v-for="(item, index) in sexList" :label="item.dictCode" :key="index">{{item.dictName}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出生日期 :" prop="birthday">
                  <el-date-picker :disabled="operation  == 'detail'" style="width: 100%" v-model="detailData.birthday" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身高 :" prop="height">
                  <el-input v-model="detailData.height" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="体重 :" prop="weight">
                  <el-input v-model="detailData.weight" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="民族 :" prop="nation">
                  <el-select :disabled="operation  == 'detail'" v-model="detailData.nation" placeholder="请选择">
                    <el-option v-for="item in nationList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="在读学校 :" prop="schoolName">
                  <el-input :disabled="operation  == 'detail'" v-model="detailData.schoolName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="家长电话 :" prop="phone">
                  <el-input v-model="detailData.phone" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="微信号 :" prop="weixin">
                  <el-input v-model="detailData.weixin" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="家庭住址 :" prop="address">
                  <el-input v-model="detailData.address" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="特长及爱好 :" prop="description">
                  <el-input type="textarea" v-model="detailData.description" :disabled="operation == 'detail'"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>

        </el-tab-pane>
        <el-tab-pane label="照片" name="6">
          <el-upload :disabled="operation == 'detail'" class="avatar-uploader" action="/singleMuseum/attach/upload" accept=".jpg,.jpeg,.png,.JPG" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img v-if="imgUrl" style="width: 100%;height:150px;object-fit:cover;" :src="imgUrl" class="avatar">
            <div v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__text">上传照片</div>
            </div>
          </el-upload>

          <!-- <div class="footer1" v-if="operation  !== 'detail'">
            <el-button @click="cancel">取消</el-button>
            <el-button @click="submit1" type="primary">确定</el-button>
          </div> -->
        </el-tab-pane>
      </el-tabs>
      <div class="footer" v-if="operation  !== 'detail'">
        <el-button @click="cancel">取消</el-button>
        <el-button @click="submit" type="primary">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      activeName: '1',
      dialogVisible: false,
      form: {},
      operation: '',
      detailId: '',
      imgUrl: '',
      resultInfo: {},
      exhibitionList: [],
      sexList: [],
      politicList: [],
      educationList: [],
      nationList: [],
      detailData: {
        realName: '',
        idCard: '',
        parentName: '',
        sex: '',
        birthday: '',
        height: '',
        weight: '',
        nation: '',
        schoolName: '',
        phone: '',
        weixin: ''
      },
      configData: {
        tableName: 'collect'
      },
    }
  },
  methods: {
    init(id, operation, type) {
      this.detailId = id
      this.operation = operation
      this.dialogVisible = true
      this.activeName = '1'
      if (this.detailId && operation != 'add') {
        this.getDetail(type)
      }
      this.getSelectDataByArr()
    },
    getDetail(type) {
      this.$http
        .get('/bsActivity/getUserDetail', {
          userId: this.detailId
        }).then(res => {
          if (res.success) {
            this.detailData = res.result || {}
            this.imgUrl = this.detailData.image
          }
        })
    },
    getSelectDataByArr() {
      this.$api.common.getSelectDataByArr({ arr: ['user_info_nation', 'user_info_politic_countenance', 'user_info_highest_education', 'user_info_sex'] }).then(res => {
        if (res.success) {
          let results = res.result
          this.nationList = results['user_info_nation']
          this.politicList = results['user_info_politic_countenance']
          this.educationList = results['user_info_highest_education']
          this.sexList = results['user_info_sex']
        }
      })

    },
    // handleClickTab() {
    //   switch (this.activeName) {
    //     case '1':
    //       this.getDetail()
    //       break
    //     // 服务记录
    //     default:
    //       break
    //   }
    // },

    cancel() {
      this.detailData = {}
      this.dialogVisible = false
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 500
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 500MB!',
          type: 'warning'
        })
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
      } else {
        this.$message.error(res.message)
      }
    },

    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.$http
            .post('/api/bsActivity/activitySign', {
              ...this.detailData,
              sex: this.detailData.parentName,
              school: this.detailData.schoolName,
              enrollType: '2',
              picture: this.imgUrl,
              activityId: this.detailId
            }).then(res => {
              if (res.success) {
                this.dialogVisible = false
                this.$message.success('新增小志愿者成功')
                this.$emit('refresh')
              }else{
                this.$message.error(res.message)

              }
            })
        }
      })
    },

    submit1() {
      if (!this.imgUrl) {
        this.$message.info('请上传志愿者证件')
        return
      }
      this.$api.volunteer.updateVolunteerAdult({
        id: this.detailData.id,
        image: this.imgUrl
      }).then(res => {
        if (res.success) {
          this.dialogVisible = false
          this.$message.success('志愿者照片修改成功')
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-volunteer-detail {
  .wrap {
    min-height: 460px;
    .content-tabs {
      min-height: 460px;
    }
  }

  .footer {
    float: right;
  }

  .footer1 {
    position: absolute;
    bottom: 30px;
    right: 30px;
  }
  .avatar-uploader {
    border: 1px dashed #8c939d;
    width: 300px;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /deep/.el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .el-icon-plus {
      font-size: 20px;
    }

    .el-upload__text {
      line-height: 1;
    }
  }

  /deep/.el-tabs__content {
    position: inherit;
  }

  .exhibition-wrapper {
    display: flex;
    .exhibition-item {
      width: 150px;
      border: 1px solid rgba(121, 121, 121, 1);
      border-radius: 5px;
      margin-right: 30px;
      margin-bottom: 10px;
      text-align: center;
      line-height: 34px;
      &.active {
        background: #0672b7;
        border-color: #0672b7;
        color: #fff;
      }

      &.c-p {
        cursor: pointer;
      }
    }
  }
}
</style>
